export { getLineHeight } from './font';
export { default as platform } from './platform';
